<template>
  <div class="catalog">
    <div class="catalog_title">{{$t('message.course_catalog')}}</div>
    <div class="catelog_main">
      <div v-for="(item,index) in course.chapters"
           :key="item.id"
           class="catalog_content"
           @click="toCourse(item,index)">
        <div class="row-align-center catalog_content_main">
          <div class="catalog_content_img">
            <img v-if="index % 3 == 0"
                 src="../../assets/web/Card 1.png"
                 class="catalog_icon_bg" />
            <img v-if="index % 3 == 1"
                 src="../../assets/web/Card 2.png"
                 class="catalog_icon_bg" />
            <img v-if="index % 3 == 2"
                 src="../../assets/web/Card 3.png"
                 class="catalog_icon_bg" />
            <img v-if="item.iconId"
                 :src="`${serverUrl}/servlet/medias/course-ware/icon/${item.iconId}`"
                 class="catalog_icon" />
          </div>
          <div style="flex:1;">
            <div class="catalog_content_title">
              {{$t('message.chapter',[$t(`message.numberToCN[${item.priority}]`)])}} {{item.title}}&nbsp;
              <img v-if="item.link && item.link != ''"
                   src="../../assets/web/Link.png"
                   style="width:20px;position: relative;top: 4px;"
                   @click.stop="openLink(item.link)" />
            </div>
            <div v-if="item.id > 0"
                 class="row-align-center justify-space-between catalog_content_main_text">
              <div><span v-if="!$store.state.isPreview">{{$t('message.learning_progress')}} {{item.fraction}}</span></div>
              <div>{{$t('message.viewed_times')}}: {{item.viewedTimes}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="toTest_btn">
        <mBtn v-if="checkHasAssessment" @click="toTest"
              width="100%"
              :disabled="$store.state.isPreview">{{$t('message.practice_test')}}</mBtn>
      </div>
    </div>
  </div>
</template>

<script>
import CourseAPI from "../../api/CourseAPI";
import UserCourseAPI from "../../api/UserCourseAPI";
import UserAssessmentsAPI from "../../api/UserAssessmentsAPI";
import { serverUrl } from "../../api/axios";
import mBtn from "../../components/mBtn";
export default {
  components: { mBtn },
  props: {
    course: Object
  },
  data () {
    return {
      loading: false,
      serverUrl: serverUrl,
      checkHasAssessment: false,
    };
  },
  methods: {
    // 參與模擬考試
    toTest () {
      // 課程不足80%提示
      if (this.course.progress < 0.8) {
        this.$alert(this.$t("message.test_tips"), this.$t("message.tips"), {
          confirmButtonText: this.$t("message.confirm"),
          callback: action => {
            console.log(action);
          }
        });
        return false;
      }

      const courseId = sessionStorage.getItem("courseId");
      const lang = this.$i18n.locale;
      this.testLoading = true;
      UserAssessmentsAPI.assessment(courseId, lang)
        .then(res => {
          this.testLoading = false;
          sessionStorage.setItem("testing", true);
          sessionStorage.setItem("questionCount", res.questionCount);
          sessionStorage.setItem("questionNum", 0);
          this.$router.push({
            path: "/learning/test"
            // query: { index: res.id }
          });
          // console.log(res);
        })
        .catch(err => {
          this.testLoading = false;
          this.$error(err);
          console.log(err);
        });
    },
    toCourse (data, index) {
      const myQuery = this.$store.state.isPreview ? this.$route.query : {};
      if (!this.$store.state.isPreview) {
        UserCourseAPI.addUserCourse(this.course.id)
          .then(() => { })
          .catch(err => {
            this.$error(err);
          });
      }
      this.$router.push({
        path: "/learning/course",
        query: {
          ...myQuery,
          chapterIndex: index,
          activeName: "content"
        }
      });
    },
    // 獲取模擬考試
    getHasAssessment() {
      if (!this.$store.state.isPreview) {
        const courseId = this.course && this.course.id;
        const locale = this.$i18n.locale;
        if (courseId) {
          CourseAPI.checkHasAssessment(courseId, locale)
            .then((res) => {
              this.checkHasAssessment = res;
            })
            .catch((err) => {
              this.$error(err);
            });
        }
      }
    },
  },
  created () {
    this.getHasAssessment();
  }
};
</script>

<style>
</style>